export const callEventTypes = {
    JourneyCall: 'JourneyCall',
    JourneyCallAgentAnswered: 'JourneyCallAgentAnswered',
    JourneyCallAgentJoined: 'JourneyCallAgentJoined',
    JourneyAgentStartCall: 'JourneyAgentStartCall',
    JourneyUserEndCall: 'JourneyUserEndCall',
    JourneyUserAcknowledgement: 'JourneyUserAcknowledgement',
}

/* Device-heartbeat events used by the HubSpot co-browse iframe view to track
   which visitor devices are online (sent by the SDK over the socket). */
export const deviceEventTypes = {
    ReplaySession: 'replay-session',
    DeviceInfo: 'device-info',
    ReferenceUpdated: 'reference-updated',
}

export const socketEventStatus = {
    Connected: 'connected',
    Disconnected: 'disconnected',
}